import React, { useRef, useState, useEffect } from 'react';
import {
  Grid,
  MenuItem,
  TextField,
  Typography,
  InputLabel,
  Box,
  Button,
  Card,
  Select,
} from '@mui/material';
import MKBox from "components/MKBox";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import Container from "@mui/material/Container";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import routes from "trainerRoutes";
import { useParams } from "react-router-dom";
import Breadcrumbs from "examples/Breadcrumbs";
import SimpleFooter from "examples/Footers/SimpleFooter";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Modal from "@mui/material/Modal";
import DatePicker from "react-multi-date-picker";
import { getAllISOCodes, getAllInfoByISO } from 'iso-country-currency';
import FormControl from '@mui/material/FormControl';
import editRoutes from "trainerEditRoutes";
import MKAlert from "components/MKAlert";
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const LoadingOverlay = ({ loading, children }) => {
  return (
    <>
      {loading && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            filter: 'blur(5px)',
            pointerEvents: 'none',
          }}
          open={loading}
        >
          <Box
            sx={{
              height: 'auto',
              p: 2,
              mx: { xs: 2, lg: 3 },
              mt: -8,
              mb: 4,
              backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
              backdropFilter: "saturate(200%) blur(30px)",
              boxShadow: ({ boxShadows: { xxl } }) => xxl,
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: "1",
              width: "100%",
              minHeight: "100vh",
              // display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          >
            {children}
          </Box>
        </Backdrop>
      )}
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: (theme) => theme.zIndex.drawer + 2,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!loading && children}
    </>
  );
};

function CustomMultipleInput({ openCalendar, value }) {
  return (
    <div>
      <input type="hidden"
        onFocus={openCalendar}
        value={value}
        readOnly
      />
      <MKButton variant="gradient" color="info" size="small" style={{ marginLeft: "40px" }} onClick={openCalendar}>Select Dates</MKButton>
    </div>
  )
}

function Author() {
  const { trainingID } = useParams();
  const [trainingDetails, setTrainingDetails] = useState([]);
  const [bbdata, setbbData] = useState([]);
  const [submitCompleted, setSubmitCompleted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [trainerDetails, setTrainerDetails] = useState([]);
  const [selectedCurrencyCountry, setSelectedCurrencyCountry] = useState('');
  const [commercialsCurrency, setCommercialsCurrency] = useState("");
  const [commercialsLessThan4hrs, setCommercialsLessThan4hrs] = useState("");
  const [commercials4hrs, setCommercials4hrs] = useState("");
  const [commercials8hrs, setCommercials8hrs] = useState("");
  const [lastDeliveredDate, setLastDeliveredDate] = useState("");
  const [lastClient, setLastClient] = useState("");
  const [courseDuration, setCourseDuration] = useState("");
  const [trainingAvailableDate, setTrainingAvailableDate] = useState([]);
  const [callAvailableDate, setCallAvailableDate] = useState([]);
  const [trainingComment, settrainingComment] = useState("");
  const [userId, setUserId] = useState("");
  const [currency, setCurrency] = useState('');
  const [trainerProfile, setTrainerProfile] = useState("");
  const [selectedTrainingCompanyId, setSelectedTrainingCompanyId] = useState("");
  const [selectedTrainingName, setSelectedTrainingName] = useState("");
  const [selectedTrainingID, setSelectedTrainingID] = useState("");
  const [lab, setLab] = useState("");
  const [labCostPerParticipants, setLabCostPerParticipants] = useState("");
  const [serverCount, setServerCount] = useState("");
  const [typeOfServer, setTypeOfServer] = useState("");
  const [maxApplyCount, setMaxApplyCount] = useState(false);
  const [trainerProfileCreate, setTrainerProfileCreate] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [mobVerified, setMobVerified] = useState(false);
  const [tcVerified, setTcVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log("trainingID", trainingID);
    fetch(`${process.env.REACT_APP_API_URL}/api/single-training-more-details/${trainingID}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setbbData(data);
          setTrainingDetails(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  console.log("trainingDetails", trainingDetails);
  console.log("data", bbdata);

  useEffect(() => {
    let id = localStorage.getItem("userId");
    setUserId(id);
    fetch(`${process.env.REACT_APP_API_URL}/api/trainer-profile-list/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setTrainerDetails(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("trainerDetails", trainerDetails);

  const handleCountryCurrencyChange = (event) => {
    const selectedISO = event.target.value;
    setSelectedCurrencyCountry(selectedISO);

    const currencyInfo = getAllInfoByISO(selectedISO);
    setCurrency(`${currencyInfo.currency} (${currencyInfo.symbol})`);
  };

  console.log("currency", currency);

  const today = new Date().toISOString().split('T')[0];
  const handleLastDeliveredDateChange = (e) => {
    setLastDeliveredDate(e.target.value);
  };
  console.log("lastDeliveredDate", lastDeliveredDate);

  const handleTrainingAvailableChange = (selectedDates) => {
    const formattedDates = selectedDates.map((date) => {
      return date.format('YYYY-MM-DD');
    });

    setTrainingAvailableDate(formattedDates);
  };

  console.log("trainingAvailableDate", trainingAvailableDate);

  const handleCallAvailableDateChange = (selectedDates) => {
    const formattedDates = selectedDates.map((date) => {
      return date.format('YYYY-MM-DD');
    });

    setCallAvailableDate(formattedDates);
  };
  console.log("callAvailableDate", callAvailableDate);


  const handleTrainingProfileChange = (e) => {
    const selectedProfile = e.target.value;
    setTrainerProfile(selectedProfile);
    const selectedExperience = trainerDetails.trainingExperience.find(
      (experience) => experience.profileName === selectedProfile
    );

    if (selectedExperience) {
      setCommercialsLessThan4hrs(selectedExperience.forLessThan4hrs || "");
      setCommercials4hrs(selectedExperience.for4hrs || "");
      setCommercials8hrs(selectedExperience.for8hrs || "");
      setCommercialsCurrency(selectedExperience.commercialsCurrency || "");
      setLastDeliveredDate(selectedExperience.dateOfLastTraining || "");
      setLastClient(selectedExperience.clientDelivered || "");
      setSelectedCurrencyCountry(selectedExperience.selectedCommercialsCurrency || "");
      setCourseDuration(selectedExperience.trainingDuration || "");
    }
  };

  const onApplyClick = (training) => {
    setLoading(true);
    let name = training.trainingName;
    let trainingId = training.id.toString();
    setSelectedTrainingName(name);
    setSelectedTrainingID(trainingId);
    let companyID = training.trainingCompanyUserID;
    setSelectedTrainingCompanyId(companyID);
    setMaxApplyCount(false);
    let id = localStorage.getItem("userId");
    console.log("userId", id);
    let permiumStatus = trainerDetails.premiumStatus;

    fetch(`${process.env.REACT_APP_API_URL}/api/single-training-details/${trainingId}/${id}/${permiumStatus}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail && data.message === "User not found") {
          console.log("123333333333333333333333333333");
          console.log("details", data.message);
          setShowModal(true);
        } else if (data.message === "Remainder reached maximum for the day") {
          console.log("123123123123");
          setMaxApplyCount(true);
          setLoading(false);
        } else {
          console.log("data inside1111111", data);
          let companyID = data.trainingCompanyUserID;
          setSelectedTrainingCompanyId(companyID);
          setShowModal(true);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  console.log("selectedTrainingName", selectedTrainingName);
  console.log("selectedTrainingID", selectedTrainingID);
  console.log("selectedTrainingCompanyId", selectedTrainingCompanyId);

  const [toc, setToc] = useState(null);
  const [tocS3BucketURL, setTocS3BucketURL] = useState(null);

  const onCloseApplyClick = () => {
    setShowModal(false);
    setCommercialsLessThan4hrs("");
    setCommercials4hrs("");
    setCommercials8hrs("");
    setLab("");
    setServerCount("");
    setTypeOfServer("");
    setLabCostPerParticipants("");
    setTrainingAvailableDate("");
    setCallAvailableDate("");
    setCourseDuration("");
    setLastDeliveredDate("");
    setLastClient("");
    settrainingComment("");
    setTrainerProfile("");
    setSelectedCurrencyCountry("");
    setCurrency("");
    setToc(null);
    setSelectionToc("");
  };

  useEffect(() => {
    let userName = localStorage.getItem("user");
    let id = localStorage.getItem("userId");
    let bucketURL = `trainerhub/${id}_${userName}`;
    setTocS3BucketURL(bucketURL);
  }, [])

  const [selectionToc, setSelectionToc] = useState("");

  const handleTocChange = (e) => {
    setSelectionToc(e.target.value);
  };
  console.log("selectionToc", selectionToc);

  const [tocError, setTocError] = useState(null);

  const tocFileInputRef = useRef(null);

  const handleUploadClick = () => {
    tocFileInputRef.current.click();
  };

  const handleTocUploadChange = (event) => {
    const selectedFile = event.target.files[0];
    const fileExtension = selectedFile.name.split('.').pop();

    if (selectedFile) {
      const allowedFormats = ['pdf', 'docx', 'xlsx', 'xls'];

      if (!allowedFormats.includes(fileExtension.toLowerCase())) {
        setTocError("Please check the file format.");
        return;
      }

      if (selectedFile.size > 5 * 1024 * 1024) {
        setTocError("File size should be maximum 5mb.");
        return;
      }
      setTocError(null);
      const renamedFile = new File([selectedFile], `${selectedTrainingName}_${selectedTrainingID}_toc.${fileExtension}`, { type: selectedFile.type });
      setToc(renamedFile);
    }
  };

  console.log("toc", toc);

  const onSaveApplyClick = async (e) => {
    setLoading(true);
    try {
      const data = {
        appliedTrainerID: userId,
        selectedTrainingID: selectedTrainingID,
        selectedTrainingName: selectedTrainingName,
        trainingCompanyUserID: selectedTrainingCompanyId,
        profileName: trainerProfile,
        applyToc: selectionToc,
        tocURL: tocS3BucketURL,
        currency: commercialsCurrency,
        commercialsForLessThan4hrs: commercialsLessThan4hrs,
        commercialsFor4hrs: commercials4hrs,
        commercialsFor8hrs: commercials8hrs,
        labsByTrainer: lab,
        serverCount: serverCount,
        typeOfServer: typeOfServer,
        labCostPerParticipants: labCostPerParticipants,
        availableDatesForTraining: trainingAvailableDate,
        availableDatesForCall: callAvailableDate,
        courseDurationHRS: courseDuration,
        recentLastDeliveredDate: lastDeliveredDate,
        recentLastDeliveredClient: lastClient,
        comments: trainingComment,
        premiumStatus: trainerDetails.premiumStatus,
        applyTrainingStatus: "1",
      };
      console.log(JSON.stringify(data));
      setLoading(true);
      setShowModal(false);
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/apply-training/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });


      if (response.ok && toc) {
        const formData = new FormData();
        formData.append('files', toc);

        console.log("formData", formData);
        console.log("s3BucketURL", tocS3BucketURL);

        fetch(`${process.env.REACT_APP_API_URL}/api/upload/${tocS3BucketURL}/applytraining/`, {
          method: 'POST',
          body: formData,
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
          })
          .catch(error => {
            console.error('Error uploading file:', error);
          });
        console.log("Toc uploaded successfully");
        setShowModal(false);
        setSubmitCompleted(true);
        setLoading(false);
      } else if (response.ok && !toc) {
        setShowModal(false);
        setSubmitCompleted(true);
        setLoading(false);
      } else {
        setShowModal(false);
        setSubmitCompleted(false);
        throw new Error("Profile is not created. Something went wrong");
      }
      // setSubmitCompleted(true);
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitCompleted(false);
    }
  };

  // const onSaveApplyClick = async (e) => {
  //   setLoading(true);
  //   try {
  //     const data = {
  //       appliedTrainerID: userId,
  //       selectedTrainingID: selectedTrainingID,
  //       selectedTrainingName: selectedTrainingName,
  //       trainingCompanyUserID: selectedTrainingCompanyId,
  //       applyToc: selectionToc,
  //       tocURL: tocS3BucketURL,
  //       currency: commercialsCurrency,
  //       commercialsForLessThan4hrs: commercialsLessThan4hrs,
  //       commercialsFor4hrs: commercials4hrs,
  //       commercialsFor8hrs: commercials8hrs,
  //       labsByTrainer: lab,
  //       serverCount: serverCount,
  //       typeOfServer: typeOfServer,
  //       labCostPerParticipants: labCostPerParticipants,
  //       availableDatesForTraining: trainingAvailableDate,
  //       availableDatesForCall: callAvailableDate,
  //       courseDurationHRS: courseDuration,
  //       recentLastDeliveredDate: lastDeliveredDate,
  //       recentLastDeliveredClient: lastClient,
  //       comments: trainingComment,
  //       applyTrainingStatus: "1",
  //     };
  //     console.log(JSON.stringify(data));

  //     const response = await fetch(`${process.env.REACT_APP_API_URL}/api/apply-training/`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: "Bearer " + localStorage.getItem("token"),
  //       },
  //       body: JSON.stringify(data),
  //     });

  //     // if (!response.ok) {
  //     //   setSubmitCompleted(false);
  //     //   throw new Error("Profile is not created. Something went wrong");
  //     // }

  //     if (response.ok && toc) {
  //       const formData = new FormData();
  //       formData.append('files', toc);

  //       console.log("formData", formData);
  //       console.log("tocS3BucketURL", tocS3BucketURL);

  //       fetch(`${process.env.REACT_APP_API_URL}/api/upload/${tocS3BucketURL}/applytraining/`, {
  //         method: 'POST',
  //         body: formData,
  //       })
  //         .then(response => response.json())
  //         .then(data => {
  //           console.log(data);
  //         })
  //         .catch(error => {
  //           console.error('Error uploading file:', error);
  //         });
  //       console.log("Toc uploaded successfully");
  //       setSubmitCompleted(true);
  //       setLoading(false);
  //     } else if (response.ok && !toc) {
  //       setSubmitCompleted(true);
  //       setLoading(false);
  //     } else {
  //       setSubmitCompleted(false);
  //       setLoading(false);
  //       throw new Error("Profile is not created. Something went wrong");
  //     }

  //   } catch (error) {
  //     console.log("Error:", error.message);
  //     setSubmitCompleted(false);
  //   }
  // };

  const DialogProfileClose = () => {
    setShowModal(false);
    window.location.href = "/app/trainerdashboard";
  };

  const onCancelClick = () => {
    window.location.href = "/app/trainerdashboard";
  };

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    setUserId(id);
    fetch(`${process.env.REACT_APP_API_URL}/api/userdetails/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setEmailVerified(data.is_verified);
          setMobVerified(data.is_verified_mobile);
          setTcVerified(data.is_verified_tc);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("token")]);

  useEffect(() => {
    let id = localStorage.getItem("userId");
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerprofileuidexists/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.exists === false && mobVerified === true && tcVerified === true && emailVerified === true) {
          setTrainerProfileCreate(true);
          window.location.href = "/app/trainerprofile";
        } else {
          setTrainerProfileCreate(false);
        }
      })
      .catch(error => {
        console.error("Error fetching data:", error);
      });
  }, [localStorage.getItem("userId")]);
  console.log("trainerProfileCreate", trainerProfileCreate);

  const handleTrainingCompanyTocDownloadClick = (trainingDetails) => {
    window.location.href = `${process.env.REACT_APP_API_URL}/api/download/${trainingDetails.TOCURL}/trainingpost/${trainingDetails.trainingName}_toc`;
  };

  return (
    <>
      <LoadingOverlay loading={loading}>
        <IdleTimeOutHandler />
        <DefaultNavbar
          routes={trainerProfileCreate ? routes : editRoutes}
        />
        <MKBox bgColor="white">
          <Card
            sx={{
              p: 2,
              mx: { xs: 2, lg: 3 },
              // mt: -8,
              mb: 4,
              // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
              backdropFilter: "saturate(200%) blur(30px)",
              boxShadow: ({ boxShadows: { xxl } }) => xxl,
            }}
          >
            <Dialog
              open={submitCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Notification !
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your application for the training has been successfully submitted. Get ready for an enriching experience ahead!
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <MKButton onClick={() => { setSubmitCompleted(false); DialogProfileClose(); }} variant="contained" color="info" size="small" autoFocus >
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <MKBox component="section" py={{ xs: 6, sm: 12 }}>
              <Container>
                <div>
                  {maxApplyCount ? (
                    <MKAlert color="error" dismissible >
                      You've reached the daily apply limit !
                    </MKAlert>
                  ) : (
                    ""
                  )}
                </div>
                <Grid container item xs={12} justifyContent="center" mx="auto">
                  <Modal open={showModal} onClose={() => setShowModal(false)} sx={{ display: "grid", placeItems: "center" }}>
                    <MKBox
                      position="relative"
                      width="850px"
                      display="flex"
                      flexDirection="column"
                      borderRadius="xl"
                      bgColor="white"
                      shadow="xl"
                      sx={{
                        overflowY: 'auto',
                        maxHeight: '90vh',
                      }}
                    >
                      <div>
                        <h2 style={{ whiteSpace: 'nowrap', marginLeft: '10px' }}>
                          {selectedTrainingName ? selectedTrainingName : 'Default Training Name'}
                        </h2>
                        <Grid container spacing={2}>
                          <Grid item xs={4} style={{ marginTop: "20px" }}>
                            <div>
                              <FormControl variant="outlined" style={{ width: '250px' }}>
                                <InputLabel style={{ marginLeft: "10px" }} id="select-trainingProfile-label">Select Your Training Profile *</InputLabel>
                                <Select
                                  labelId="select-trainingProfile-label"
                                  label="Select Your Training Profile *"
                                  fullWidth
                                  onChange={handleTrainingProfileChange}
                                  value={trainerProfile}
                                  style={{ minHeight: '44px', width: '250px', marginLeft: "10px" }}
                                >
                                  {trainerDetails.trainingExperience &&
                                    trainerDetails.trainingExperience.map((experience, index) => (
                                      <MenuItem key={index} value={experience.profileName}>
                                        {experience.profileName}
                                      </MenuItem>
                                    ))}
                                </Select>
                              </FormControl>
                            </div>
                          </Grid>
                          <Grid item xs={4} style={{ marginTop: "20px" }}>
                            <div>
                              <FormControl variant="outlined" style={{ width: '250px' }}>
                                <InputLabel id="country-currency" shrink={!!selectedCurrencyCountry}>Country *</InputLabel>
                                <Select
                                  labelId="country-currency"
                                  label="Country *"
                                  fullWidth
                                  onChange={handleCountryCurrencyChange}
                                  value={selectedCurrencyCountry}
                                  style={{ minHeight: '44px' }}
                                >
                                  {getAllISOCodes().map((country) => (
                                    <MenuItem key={country.iso} value={country.iso}>
                                      {country.countryName}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          </Grid>
                          <Grid item xs={4} style={{ marginTop: "20px" }}>
                            <div>
                              <Typography variant="subtitle2" style={{ marginTop: "10px" }}>
                                <span>Currency: {commercialsCurrency}</span>
                              </Typography>
                            </div>
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "20px", marginRight: "22px" }}>
                            <Breadcrumbs
                              routes={[{ label: "Commercials per hour" }]}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={4} style={{ marginTop: "20px" }}>
                            <div>
                              <TextField
                                label="For less than 4 hours *"
                                variant="outlined"
                                style={{ width: '250px', marginLeft: "10px" }}
                                value={commercialsLessThan4hrs}
                                onChange={(e) => setCommercialsLessThan4hrs(e.target.value)}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={4} style={{ marginTop: "20px" }}>
                            <div>
                              <TextField
                                label="For 4 hours *"
                                variant="outlined"
                                style={{ width: '250px' }}
                                value={commercials4hrs}
                                onChange={(e) => setCommercials4hrs(e.target.value)}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={4} style={{ marginTop: "20px" }}>
                            <div>
                              <TextField
                                label="For 8 hours *"
                                variant="outlined"
                                style={{ width: '250px' }}
                                value={commercials8hrs}
                                onChange={(e) => setCommercials8hrs(e.target.value)}
                              />
                            </div>
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={4} style={{ marginTop: "30px" }}>
                            <div>
                              <InputLabel style={{ marginLeft: '10px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>
                                Last Delivered Date
                              </InputLabel>
                              <TextField
                                type="month"
                                id="lastDelivered_date"
                                value={lastDeliveredDate || ""}
                                onChange={handleLastDeliveredDateChange}
                                style={{ width: "250px", marginLeft: "10px" }}
                                InputProps={{
                                  inputProps: {
                                    max: new Date().toISOString().split('T')[0].substring(0, 7),
                                  },
                                }}
                                fullwidth
                              />
                            </div>
                          </Grid>
                          <Grid item xs={4} style={{ marginTop: "30px" }}>
                            <div>
                              <TextField
                                label="Last Delivered Client"
                                variant="outlined"
                                style={{ width: '250px' }}
                                value={lastClient}
                                onChange={(e) => setLastClient(e.target.value)}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={4} style={{ marginTop: "30px" }}>
                            <div>
                              <TextField
                                label="Training Duration (in hours) *"
                                variant="outlined"
                                style={{ width: '250px' }}
                                value={courseDuration}
                                onChange={(e) => setCourseDuration(e.target.value)}
                              />
                            </div>
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "20px", marginRight: "22px" }}>
                            <Breadcrumbs
                              routes={[{ label: "Available Dates For Training" }]}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "10px" }}>
                            <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', marginLeft: '10px', fontSize: '0.9rem' }}>
                              From When
                              <DatePicker
                                multiple
                                id="selectedDates"
                                style={{ marginLeft: '20px' }}
                                render={<CustomMultipleInput />}
                                onChange={handleTrainingAvailableChange}
                                value={trainingAvailableDate}
                                minDate={new Date()}
                              />
                            </Typography>
                            {trainingAvailableDate.length > 0 && (
                              <Typography style={{ marginTop: '5px' }} variant="body2" fontWeight="regular">
                                <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', marginLeft: '10px', fontSize: '0.9rem' }} component="span">
                                  Selected Dates For Training:
                                </Typography>{' '}
                                {trainingAvailableDate.join(', ')}
                              </Typography>
                            )}
                          </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                          <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "20px", marginRight: "22px" }}>
                            <Breadcrumbs
                              routes={[{ label: "Available Dates For Calls" }]}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "10px" }}>
                            <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', marginLeft: '10px', fontSize: '0.9rem' }}>
                              From When
                              <DatePicker
                                multiple
                                id="selectedDates"
                                style={{ marginLeft: '20px' }}
                                render={<CustomMultipleInput />}
                                onChange={handleCallAvailableDateChange}
                                value={callAvailableDate}
                                minDate={new Date()}
                              />
                            </Typography>
                            {callAvailableDate.length > 0 && (
                              <Typography style={{ marginTop: '5px' }} variant="body2" fontWeight="regular">
                                <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', marginLeft: '10px', fontSize: '0.9rem' }} component="span">
                                  Selected Dates For Call:
                                </Typography>{' '}
                                {callAvailableDate.join(', ')}
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                            <div>
                              <TextField
                                label="Note"
                                multiline
                                rows={4}
                                variant="outlined"
                                style={{ width: '530px', marginLeft: "10px" }}
                                value={trainingComment}
                                onChange={(e) => {
                                  settrainingComment(e.target.value);
                                }}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={4} style={{ marginTop: "10px", marginLeft: "280px" }}>
                            <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', fontSize: '0.9rem' }}>
                              Is TOC available? *
                            </Typography>

                            <FormControl component="fieldset" style={{ marginLeft: '0px' }}>
                              <RadioGroup row aria-label="toc" name="selectionToc" value={selectionToc} onChange={handleTocChange}>
                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                  <FormControlLabel value="yes" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="Yes" />
                                  <FormControlLabel value="no" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="No" />
                                </Box>
                              </RadioGroup>
                            </FormControl>
                            {selectionToc === 'yes' && (
                              <>
                                <MKTypography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', fontSize: '0.9rem' }}>
                                  TOC format in .pdf, .docx, .xlsx, .xls
                                </MKTypography>
                                <input
                                  type="file"
                                  id="toc-upload"
                                  accept="pdf/*"
                                  style={{ display: 'none' }}
                                  ref={tocFileInputRef}
                                  onChange={handleTocUploadChange}
                                />
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <label htmlFor="toc-upload">
                                    <MKButton onClick={handleUploadClick} variant="gradient" color="info" size="small" style={{ whiteSpace: 'nowrap' }}>
                                      Upload TOC
                                    </MKButton>
                                  </label>
                                  {toc && (
                                    <div style={{ fontSize: '14px', marginLeft: "10px" }}>
                                      <span> {toc.name}</span>
                                    </div>
                                  )}
                                  {tocError && (
                                    <MKTypography style={{ color: 'red', fontSize: 'small', marginLeft: '20px', marginTop: '5px' }}>
                                      {tocError}
                                    </MKTypography>
                                  )}
                                </div>
                              </>
                            )}
                          </Grid>
                        </Grid>
                        <div style={{ display: 'flex', marginBottom: "20px", marginLeft: "10px" }}>
                          <MKButton variant="gradient" color="info" size="small" onClick={onCloseApplyClick}>
                            Cancel
                          </MKButton>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-50px", marginRight: "10px", marginBottom: "10px" }}>
                          <MKButton variant="gradient" color="info" size="small" disabled={!trainerProfile || !selectedCurrencyCountry || !commercialsLessThan4hrs || !commercials4hrs || !commercials8hrs || !courseDuration || !selectionToc} onClick={onSaveApplyClick}>
                            Apply
                          </MKButton>
                        </div>
                      </div>
                    </MKBox>
                  </Modal>

                  <Grid container justifyContent="center" py={6} style={{ marginTop: "-50px" }}>
                    <Grid item xs={12} md={12} mx={{ xs: "auto", sm: 6, md: 1 }}>
                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <Typography variant="h3">{trainingDetails.trainingName}</Typography>
                      </MKBox>

                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <Grid item>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Posted by :
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "10px" }}>
                            {trainingDetails.trainingCompanyName}
                          </Typography>
                        </Grid>
                      </MKBox>

                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <Grid item>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Technology:
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "10px" }}>
                            {trainingDetails.technology}
                          </Typography>
                        </Grid>
                      </MKBox>

                      <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                        <Grid item xs={12}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Training Details</span> }]} />
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Mode Of Training :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "48px" }}>
                            {trainingDetails.trainingMode}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Training Location :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "40px" }}>
                            {trainingDetails.trainingMode === "Virtual" ? "N/A" : trainingDetails.trainingLocations}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Time Zone :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "40px" }}>
                            {trainingDetails.timeZone}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Audience Level :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "65px" }}>
                            {trainingDetails.audienceLevel}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Training Expectation :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "20px" }}>
                            {trainingDetails.trainingExpectation}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Training Type :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "20px" }}>
                            {trainingDetails.trainingType}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Total Participants :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "47px" }}>
                            {trainingDetails.totalParticipants}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Total Training Budget :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "15px" }}>
                            {trainingDetails.currency}&nbsp;{trainingDetails.totalTrainingBudget}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Total Duration :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            {trainingDetails.duration}&nbsp;hours
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Training Timing :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "65px" }}>
                            {trainingDetails.trainingTiming}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Start Time :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "95px" }}>
                            {trainingDetails.startTime}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "5px" }}>
                            End Time :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "45px" }}>
                            {trainingDetails.endTime}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Expected Start Date :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "34px" }}>
                            {trainingDetails.expectedStartDate}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Expected End Date :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "35px" }}>
                            {trainingDetails.deadline}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            TOC Available :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "23px" }}>
                            {trainingDetails.tocAvailable === 'yes' ? 'Yes' : 'No'}
                          </Typography>
                        </Grid>
                      </Grid>

                      {trainingDetails.tocAvailable === 'yes' && (
                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                            <MKButton variant="gradient" color="info" size="small" style={{ padding: '5px 10px' }} onClick={() => handleTrainingCompanyTocDownloadClick(trainingDetails)}>
                              Download Training Partner TOC
                            </MKButton>
                          </Grid>
                        </Grid>
                      )}

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={12}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Training Schedule :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "48px" }}>
                            {trainingDetails.trainingSchedule
                              ? trainingDetails.trainingSchedule
                                .replace(/\[|\]/g, "")
                                .split(", ")
                                .join(", ")
                              : ""}
                          </Typography>
                        </Grid>
                      </Grid>

                      {trainingDetails.trainingScheduleComment && (
                        <>
                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={2}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Schedule Comments :&nbsp;
                              </Typography>
                            </Grid>
                            <Grid item xs={10}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                                {trainingDetails.trainingScheduleComment} <br />
                              </Typography>
                            </Grid>
                          </Grid>
                        </>
                      )}

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={2}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Requirements :&nbsp;
                          </Typography>
                        </Grid>
                        <Grid item xs={10}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                            {trainingDetails.requirements} <br />
                          </Typography>
                        </Grid>
                      </Grid>

                      {trainerDetails.premiumStatus === "yes" && (
                        <>
                          <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                            <Grid item xs={12}>
                              <Breadcrumbs
                                routes={[{ label: <span style={{ fontWeight: 'bold' }}>Training Partner's Contact Details</span> }]}
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Contact Person Name :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "37px" }}>
                                {trainingDetails.contactPerson}
                              </Typography>
                            </Grid>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                Email - ID :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "50px" }}>
                                {trainingDetails.email}&nbsp;
                              </Typography>
                            </Grid>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text">
                                Mobile Number :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "70px" }}>
                                {trainingDetails.mobileNumber}&nbsp;
                              </Typography>
                            </Grid>
                          </Grid>

                        </>
                      )}

                    </Grid>
                  </Grid>
                  <Grid container justifyContent="center" spacing={2} mt={2} style={{ marginTop: "-40px", marginBottom: "-80px" }}>
                    <Grid item>
                      <MKButton
                        variant="gradient"
                        color="info"
                        size="small"
                        onClick={() => onCancelClick()}
                        style={{ padding: '5px 10px' }}
                      >
                        Cancel
                      </MKButton>
                    </Grid>
                    <Grid item>
                      <MKButton
                        variant="gradient"
                        color="info"
                        size="small"
                        onClick={() => onApplyClick(trainingDetails)}
                        style={{ padding: '5px 10px' }}
                      >
                        Apply
                      </MKButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Container>

            </MKBox>
          </Card>
          <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
              <SimpleFooter />
            </MKBox>
          </div>
        </MKBox>
      </LoadingOverlay>
    </>
  );
}

export default Author;
